import {Injectable} from '@angular/core';
import { DatePipe } from '@angular/common';
import {timeZones} from '../../../environments/environment';
import moment from 'moment';

@Injectable()
export class TimeService {
    constructor(private datePipe: DatePipe) {
    }

    fromUTCToLocal(data: string | null | undefined, timeZone: string | undefined, format = 'yyyy-MM-dd HH:mm') {
        if (!data) { 
            return;
        }
        const utcDate = moment.utc(data).format();
        return this.datePipe.transform(utcDate, format, timeZone);
    }

    getTimeZoneGroup(timeZone: string): string | undefined {
        return timeZones.filter(x => x.value === timeZone).map(y => y.group)[0];
    }

    areDifferentDates(dateString1: string, dateString2: string): boolean {
        const date1 = moment.utc(dateString1);
        const date2 = moment.utc(dateString2);
        return date1.year() !== date2.year() || date1.month() !== date2.month() || date1.date() !== date2.date();
    }
}
